import React from 'react';
import { Button, Table, TrashcanIcon } from 'react-unity';
import AWSAPermissionInfo from '../../models/entities/AWSPermissionInfo';
import './AwsSSOHomeTableRow.css';

interface AwsSSOHomeTableRowProps {
    assignedPermission: AWSAPermissionInfo;
    index: number;
    setConfirmModalVisible: any;
    setPermissionsSelected: any;
    operationInProgress: boolean;
}

const AwsSSOHomeTableRow = ({
    assignedPermission,
    index,
    setConfirmModalVisible,
    setPermissionsSelected,
    operationInProgress
} : AwsSSOHomeTableRowProps) => {
    
    const handleClick = (assignedPermission: AWSAPermissionInfo) => {
        setPermissionsSelected(assignedPermission);
        setConfirmModalVisible(true);
    }

    return (
        <Table.Body.Row key={index}>
            <Table.Body.Cell>
                {assignedPermission.permissionSetName}
            </Table.Body.Cell>
            <Table.Body.Cell>
                {assignedPermission.principal?.name}
            </Table.Body.Cell>
            <Table.Body.Cell>
                {assignedPermission.principal?.externalID}
            </Table.Body.Cell>
            <Table.Body.Cell>
               <Button
                    style={{ zIndex: 0 }}
                    variant="primary"
                    size="small"
                    disabled={operationInProgress}
                    onClick={() => handleClick(assignedPermission)}
                >
                    <TrashcanIcon size="small" />
                </Button>
            </Table.Body.Cell>
        </Table.Body.Row>
    );
};

export default AwsSSOHomeTableRow;